import { Popover } from 'bootstrap/dist/js/bootstrap.bundle';

document.addEventListener('DOMContentLoaded', function () {
    const trigger = document.getElementById('searchBarUserIconButton');
    const source  = document.querySelector('.searchBarUserContainer');

    new Popover(trigger, {
        container: 'body',
        html: true,
        content: () => {
            const clone = source.cloneNode(true);
            clone.style.display = '';
            return clone;
        },
        sanitize: false,
        customClass: "searchBarUserCardPopover"
    });
});
